export const _setStudentProfileDetails = (state, action) => action.payload;
